import React, { h } from 'preact'
import { Box } from './box'
import { Logo } from './logo'

import style from './powered-by.css'

export const PoweredBy: React.FunctionalComponent = () => {
    const handleClick = (): void => {
        window.location.href = 'https://www.logixboard.com'
    }

    return (
        <Box className={style.container} onClick={handleClick}>
            <div className={style.poweredText}>Powered By</div>
            <Logo />
        </Box>
    )
}
